import { z } from 'zod';
import { serverIdsQuerySchema, uuidSchema } from './schemas.js';
export const REQUEST_SERVICE_TYPES = ['seerr'];
export const MEDIA_REQUEST_STATUSES = [
    'pending',
    'approved',
    'declined',
    'failed',
    'completed',
];
const urlField = z
    .string()
    .trim()
    .min(1)
    .max(500)
    .transform((value) => value.replace(/\/+$/, ''));
const apiKeyField = z.string().trim().min(1).max(500);
export const testRequestServiceSchema = z.strictObject({
    url: urlField,
    apiKey: apiKeyField,
});
export const createRequestServiceSchema = z.strictObject({
    serverId: uuidSchema,
    url: urlField,
    apiKey: apiKeyField,
    name: z.string().trim().min(1).max(100).optional(),
});
/** apiKey omitted keeps the stored key; a string replaces it. */
export const updateRequestServiceSchema = z.strictObject({
    name: z.string().trim().min(1).max(100).optional(),
    url: urlField.optional(),
    apiKey: apiKeyField.optional(),
    enabled: z.boolean().optional(),
});
export const REQUEST_UNPLAYED_SORTS = ['fileSizeBytes', 'waitMs', 'requestedAt', 'title'];
export const REQUESTER_SORTS = [
    'watchedByOthers',
    'requested',
    'landed',
    'watched',
    'medianWaitMs',
    'name',
];
export const requestsAnalyticsQuerySchema = z.object({
    serverIds: serverIdsQuerySchema,
});
const requestsPageFields = {
    serverIds: serverIdsQuerySchema,
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
};
export const requestsUnplayedQuerySchema = z.object({
    ...requestsPageFields,
    sortBy: z.enum(REQUEST_UNPLAYED_SORTS).default('fileSizeBytes'),
});
export const requestersQuerySchema = z.object({
    ...requestsPageFields,
    sortBy: z.enum(REQUESTER_SORTS).default('watched'),
});
export const userRequestsQuerySchema = z.object({
    scope: z.enum(['identity']).optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(5),
});
//# sourceMappingURL=requests.js.map